import React, {PropTypes} from 'react';
import {viewOrderArr} from '../viewOrderArr';
import cx from 'classnames';

// components
import Modal from '../../../common/components/r_Modal';
import ModalX from '../../../common/svgs/ModalX';
import FlatButton from '../../../common/components/c_FlatButton';
import RaisedButton from '../../../common/components/c_RaisedButton';

const secondaryButtonStyle = {
  width: '296px',
  height: '41px',
  marginLeft: '25px'
};

const secondaryButtonLabelStyle = {
  fontSize: '12px',
  transform: 'translateY(-.5px)',
  top: 0
};


export default function RouteTransitionBlocker(props) {
  const text = (props.transitionText) ? props.transitionText :
  [
    `You have not completed the required fields needed to save. <br/>
    If you exit the page now you will lose the information that hasn’t been saved.`
  ];

  const className = props.className || '';

  return (
    <Modal>
      <div className={`route-transition-blocker-transition-block-form${className && '-' + className}`}>
        <div>
          <div className='prompt-text' dangerouslySetInnerHTML={{__html: text}}>

          </div>

          {props.control
            &&
            <div className='transition-control'>
              {props.control}
            </div>
          }

          <RaisedButton
            label={props.primaryButtonLabel || 'Stay'}
            onClick={props.primaryAction}
          />
          <FlatButton
            style={secondaryButtonStyle}
            labelStyle={secondaryButtonLabelStyle}
            label={props.secondaryButtonLabel || 'Leave'}
            onClick={props.secondaryAction}
          />
        </div>
        <ModalX onClick={props.cancelAction}/>
      </div>
      <div className='rectangle-behind-modal-form absolute-center'/>
    </Modal>
  );
}

RouteTransitionBlocker.propTypes = {
  primaryAction         : PropTypes.func,
  secondaryAction       : PropTypes.func,
  cancelAction          : PropTypes.func,
  transitionText        : PropTypes.text,
  primaryButtonLabel    : PropTypes.string,
  secondaryButtonLabel  : PropTypes.string,
  control               : PropTypes.element,
  className             : PropTypes.string,
};



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_RouteTransitionBlocker/index.js